module.exports = __webpack_public_path__ + "img/progress-bar.162155a2.png";